$(document).ready(function() {
  $("#to_year").on("change",function(){
    if ($(this).val() == new Date().getFullYear()) {
      $(this).bootstrapDP('destroy')
      $(this).bootstrapDP({
        format: 'dd M yyyy',
        weekStart: 12,
        minViewMode: 2,
        autoclose: true,
        startDate:'2015',
        endDate: new Date(),
        orientation: "bottom",
        language: I18n.locale
      });
      $(this).bootstrapDP('update', moment().format('D MMM YYYY'));
    }else{
      $('.input-daterange').bootstrapDP('destroy')
      initDaterange();
    }
  }).change();

  function initDaterange() {
    $('.input-daterange').bootstrapDP({
      format: "yyyy",
      weekStart: 12,
      minViewMode: 2,
      autoclose: true,
      startDate:'2015',
      endDate: new Date(),
      orientation: "bottom",
      language: I18n.locale
    });
  }
});
